import { reqOrderDetail } from '@/api/reservation'
import { reqServiceList } from '@/api/hail'

export default {
  async fetchServiceList({ commit }) {
    const { result } = await reqServiceList()
    commit('setServiceList', result.serviceList)
  },
  async fetchOrderDetail({ state, commit }) {
    try {
      const { result } = await reqOrderDetail(state.id)
      commit('setModal', result)
    } catch (e) {
      console.error(e)
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/reserveModal/actions.js